import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { PersonSummary } from '~/models/administration/person';
import { UserListing, UserSummary } from '~/models/administration/user';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class UsersService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.administration);
  }

  personAdded: EventEmitter<any> = new EventEmitter();
  personUpdated: EventEmitter<any> = new EventEmitter();

  getUser(id: string) {
    return this.http.get<UserSummary>(this._url(`/${id}`));
  }

  getUsers(paramsObj?: any, model?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<UserSummary[]>(this._url(`/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  getPersonsIsUsers(siteIds?: any[]) {
    return this.http.post<any>(this._url(`/persons-is-users`), siteIds);
  }

  getPersonsBySiteIds(siteIds?: any[]) {
    return this.http.post<any>(this._url(`/persons-by-siteIds`), siteIds);
  }

  getPersons() {
    return this.http.get<any>(this._url(`/persons`));
  }

  getPersonById(id: number) {
    return this.http.get<any>(this._url(`/person-by-id/${id}`));
  }

  getActivePersons(paramsObj?: any, screenSiteId?: number, accountIds?: any) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.accountIds = accountIds;
    let params = createHttpParams(paramsObj);

    return this.http.get<PersonSummary[]>(this._url(`/active-persons`), { params, observe: 'response' });
  }

  getPersonsGridData(paramsObj?: any, model?: any, DistinctPersonCodes?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.view = 'summary';
    paramsObj.DistinctPersonCodes = DistinctPersonCodes;

    let params = createHttpParams(paramsObj);

    return this.http.post<any[]>(this._url(`/persons-grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  getUsersList() {
    return this.http.get<UserListing>(this._url(`/listing`));
  }

  getActiveUsersList() {
    return this.http.get<UserListing>(this._url(`/active-listing`));
  }

  deactivateUser(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  deactivateUserBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }

  reactivateUser(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  reactivateUserBatch(obj: any) {
    return this.client.put(this._url(`/batchReactivate`), obj);
  }

  deactivatePerson(obj: any) {
    return this.client.put(this._url(`/deactivate-person`), obj);
  }

  deactivatePersonBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate-person`), obj);
  }

  reactivatePerson(obj: any) {
    return this.client.put(this._url(`/reactivate-person`), obj);
  }

  reactivatePersonBatch(obj: any) {
    return this.client.put(this._url(`/batchReactivate-person`), obj);
  }

  getUserActivityLogsByRange(obj: any) {
    return this.http.post(this._url(`/getUserActivityLogsByRange`), obj);
  }

  getUserLatestActivityLogs(id: string, count: number) {
    return this.http.get(this._url(`/getUserLatestActivityLogs/${id}/${count}`));
  }

  getloggedInUsers(paramsObj?: any, model?: any) {
    //return this.http.get(this._url(`/getLoggedUsers`));

    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<UserSummary[]>(this._url(`/getLoggedInUsers-grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/users${v}`);
  }
}
